import { IconCheck, IconMail } from "@tabler/icons-react";
import { Button } from "../ui/Button";
import { useMemo, useState } from "react";
import { useAssignmentById } from "@/store/selectors/assignmentSelectors";
import { useActiveUserPartner } from "@/store/selectors";
import { config } from "@/config";
import { Analytics } from "@/services/Analytics";

export function CopyAssignmentEmailTemplate({
  assignmentId,
  disabled,
}: {
  assignmentId: string;
  disabled?: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const assignment = useAssignmentById(assignmentId);
  const userPartner = useActiveUserPartner();
  const partnerSlug = userPartner?.slug;

  const emailTemplate = useMemo(() => {
    if (!assignment) {
      return "";
    }

    let link = `${window.location.origin}/assignments/${assignmentId}`;
    if (link.includes("localhost:5183")) {
      link = link.replace("localhost:5183", "localhost:5173");
    }

    if (link.includes("partner.advizehub.com")) {
      link = link.replace("partner.advizehub.com", "students.advizehub.com");
    }
    if (partnerSlug) {
      link = `${link}?partner=${partnerSlug}`;
    }

    return `Hello class,

Below are details for a fun new career exploration exercise, "${assignment?.title}"!

This exercise involves watching short interview videos from real professionals about their careers through a career learning tool called Advize.

Everything you need is available at the link below:
${link}

Please finish the assignment by {INSERT DUE DATE}!

Reach out to me with any questions! And if you have any technical issues or feedback for Advize, you can email their team directly at ${config.supportEmail}.
`;
  }, [assignment, assignmentId, partnerSlug]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(emailTemplate);
    setCopied(true);

    Analytics.assignmentCopyEmailTemplate({
      assignmentId,
      assignmentTitle: assignment?.title,
      label: emailTemplate,
    });

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <Button
      variant="light"
      radius="xl"
      size="sm"
      fullWidth
      disabled={disabled}
      leftSection={copied ? <IconCheck size={16} /> : <IconMail size={16} />}
      onClick={copyToClipboard}
    >
      {copied ? "Copied" : "Copy email template"}
    </Button>
  );
}
